import React, { useState, useEffect } from 'react';
import './App.css';
import { supabase } from './supabase';

const API = process.env.REACT_APP_API_URL || 'https://church-app-tp0x.onrender.com';

function App() {
  const [session, setSession] = useState(null);
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [members, setMembers] = useState([]);
  const [campuses, setCampuses] = useState([]);
  const [tags, setTags] = useState([]);
  const [stats, setStats] = useState(null);
  const [emailHistory, setEmailHistory] = useState([]);
  const [smsHistory, setSmsHistory] = useState([]);
  const [posts, setPosts] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [commsChannel, setCommsChannel] = useState('email');
  const [emailTo, setEmailTo] = useState('');
  const [emailToName, setEmailToName] = useState('');
  const [smsTo, setSmsTo] = useState('');
  const [smsToName, setSmsToName] = useState('');
  const [memberSearch, setMemberSearch] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailMessage, setEmailMessage] = useState('');
  const [emailStatus, setEmailStatus] = useState('');
  const [smsMessage, setSmsMessage] = useState('');
  const [smsStatus, setSmsStatus] = useState('');
  const [includeOptOutFooter, setIncludeOptOutFooter] = useState(true);
  const [audienceType, setAudienceType] = useState('individual');

  // Push notifications
  const [pushTitle, setPushTitle] = useState('');
  const [pushBody, setPushBody] = useState('');
  const [pushLink, setPushLink] = useState('');
  const [pushStatus, setPushStatus] = useState('');
  const [pushHistory, setPushHistory] = useState([]);
  const [pushReach, setPushReach] = useState(null);
  const [selectedCampus, setSelectedCampus] = useState('');
  const [selectedTag, setSelectedTag] = useState('');
  const [showAddMember, setShowAddMember] = useState(false);
  const [newMember, setNewMember] = useState({
    first_name: '', last_name: '', email: '', phone: '', campus_id: '', status: 'visitor'
  });
  const [memberStatus, setMemberStatus] = useState('');
  const [newTag, setNewTag] = useState({ name: '', color: '#1F3D34' });
  const [tagStatus, setTagStatus] = useState('');
  const [memberTags, setMemberTags] = useState({});
  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedTagToAdd, setSelectedTagToAdd] = useState('');
  const [newPost, setNewPost] = useState({
    title: '',
    body: '',
    campus_id: '',
    category: 'announcement',
    image_url: '',
    status: 'draft'
  });
  const [postStatus, setPostStatus] = useState('');
  const [editingPostId, setEditingPostId] = useState(null);

  // Editing state for members / campuses / tags
  const [editingMemberId, setEditingMemberId] = useState(null);
  const [memberDraft, setMemberDraft] = useState({});
  const [showAddCampus, setShowAddCampus] = useState(false);
  const [newCampus, setNewCampus] = useState({ name: '', city: '', lat: '', lng: '' });
  const [editingCampusId, setEditingCampusId] = useState(null);
  const [campusDraft, setCampusDraft] = useState({});
  const [campusStatus, setCampusStatus] = useState('');
  const [editingTagId, setEditingTagId] = useState(null);
  const [tagDraft, setTagDraft] = useState({ name: '', color: '#1F3D34' });

  // Member detail (drill-in)
  const [memberDetailId, setMemberDetailId] = useState(null);
  const [memberDetail, setMemberDetail] = useState(null);

  // Groups
  const [groups, setGroups] = useState([]);
  const [showGroupForm, setShowGroupForm] = useState(false);
  const [editingGroupId, setEditingGroupId] = useState(null);
  const emptyGroup = {
    name: '', description: '', category: 'small_group',
    meeting_day: '', meeting_time: '', location: '',
    leader_name: '', leader_contact: '',
    image_url: '', capacity: '', campus_id: '', status: 'draft'
  };
  const [groupDraft, setGroupDraft] = useState(emptyGroup);
  const [groupStatus, setGroupStatus] = useState('');
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [groupRoster, setGroupRoster] = useState([]);

  // Analytics
  const [analyticsOverview, setAnalyticsOverview] = useState(null);
  const [analyticsSeries, setAnalyticsSeries] = useState([]);
  const [analyticsEngagement, setAnalyticsEngagement] = useState(null);
  const [analyticsMembers, setAnalyticsMembers] = useState([]);

  // Devotionals
  const [devotionals, setDevotionals] = useState([]);
  const [showDevoForm, setShowDevoForm] = useState(false);
  const [editingDevoId, setEditingDevoId] = useState(null);
  const emptyDevo = {
    title: '', body: '', scripture_reference: '', scripture_text: '',
    reflection_question: '', author: '', image_url: '',
    available_on: '', series: '', status: 'draft'
  };
  const [devoDraft, setDevoDraft] = useState(emptyDevo);
  const [devoStatus, setDevoStatus] = useState('');

  // Sermons
  const [sermons, setSermons] = useState([]);
  const [showSermonForm, setShowSermonForm] = useState(false);
  const [editingSermonId, setEditingSermonId] = useState(null);
  const emptySermon = {
    title: '', description: '', series: '', speaker: '',
    scripture_reference: '', video_url: '', audio_url: '', thumbnail_url: '',
    duration_seconds: '', campus_id: '', preached_at: '', status: 'draft'
  };
  const [sermonDraft, setSermonDraft] = useState(emptySermon);
  const [sermonStatus, setSermonStatus] = useState('');

  // Events
  const [events, setEvents] = useState([]);
  const [eventsFilter, setEventsFilter] = useState('upcoming'); // upcoming | past | all
  const [showEventForm, setShowEventForm] = useState(false);
  const [editingEventId, setEditingEventId] = useState(null);
  const emptyEvent = {
    title: '', description: '', start_at: '', end_at: '',
    location: '', campus_id: '', category: 'community',
    capacity: '', image_url: '', registration_open: true, status: 'draft'
  };
  const [eventDraft, setEventDraft] = useState(emptyEvent);
  const [eventStatus, setEventStatus] = useState('');
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [registrations, setRegistrations] = useState([]);
  const [rosterSearch, setRosterSearch] = useState('');

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
    })
    supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })
  }, [])

  useEffect(() => {
    if (!session) return
    fetch(`${API}/members`)
      .then(res => res.json())
      .then(data => {
        setMembers(data)
        data.forEach(m => loadMemberTags(m.id))
      });
    fetch(`${API}/campuses`)
      .then(res => res.json())
      .then(data => setCampuses(data));
    fetch(`${API}/tags`)
      .then(res => res.json())
      .then(data => setTags(data));
    fetch(`${API}/stats`)
      .then(res => res.json())
      .then(data => setStats(data));
    fetch(`${API}/email-history`)
      .then(res => res.json())
      .then(data => setEmailHistory(data));
    fetch(`${API}/sms-history`)
      .then(res => res.json())
      .then(data => setSmsHistory(data));
    fetch(`${API}/push-history`)
      .then(res => res.json())
      .then(data => setPushHistory(data));
    fetch(`${API}/posts`)
      .then(res => res.json())
      .then(data => setPosts(data));
    fetch(`${API}/events?status=all&when=all`)
      .then(res => res.json())
      .then(data => setEvents(data));
    fetch(`${API}/sermons?status=all`)
      .then(res => res.json())
      .then(data => setSermons(data));
    fetch(`${API}/devotionals?status=all`)
      .then(res => res.json())
      .then(data => setDevotionals(data));
    fetch(`${API}/groups?status=all`)
      .then(res => res.json())
      .then(data => setGroups(data));
  }, [session]);

  // Lazy-load analytics only when tab is opened
  useEffect(() => {
    if (!session || activeTab !== 'analytics') return;
    fetch(`${API}/analytics/overview`).then(r => r.json()).then(setAnalyticsOverview).catch(()=>{});
    fetch(`${API}/analytics/timeseries?days=30`).then(r => r.json()).then(setAnalyticsSeries).catch(()=>{});
    fetch(`${API}/analytics/engagement?days=30`).then(r => r.json()).then(setAnalyticsEngagement).catch(()=>{});
    fetch(`${API}/analytics/members-last-seen?limit=25`).then(r => r.json()).then(setAnalyticsMembers).catch(()=>{});
  }, [session, activeTab]);

  const login = async () => {
    setLoginError('')
    const { error } = await supabase.auth.signInWithPassword({
      email: loginEmail,
      password: loginPassword
    })
    if (error) setLoginError(error.message)
  }

  const logout = async () => {
    await supabase.auth.signOut()
    setSession(null)
  }

  const filteredMembers = members.filter(m =>
    `${m.first_name} ${m.last_name}`.toLowerCase().includes(memberSearch.toLowerCase())
  )

  // Returns recipient strings for the current audience. `field` is 'email' or 'phone'.
  const getAudience = (field = 'email') => {
    if (audienceType === 'individual') {
      const direct = field === 'email' ? emailTo : smsTo
      return direct ? [direct] : []
    }
    if (audienceType === 'all') return members.map(m => m[field]).filter(Boolean)
    if (audienceType === 'campus') return members
      .filter(m => m.campus_id === parseInt(selectedCampus))
      .map(m => m[field])
      .filter(Boolean)
    if (audienceType === 'tag') {
      const taggedMemberIds = Object.entries(memberTags)
        .filter(([, mtags]) => mtags.some(t => t && t.id === parseInt(selectedTag)))
        .map(([id]) => parseInt(id))
      return members
        .filter(m => taggedMemberIds.includes(m.id))
        .map(m => m[field])
        .filter(Boolean)
    }
    return []
  }

  const sendEmail = async () => {
    const audience = getAudience('email')
    if (audience.length === 0) {
      setEmailStatus('No recipients found ❌')
      return
    }
    setEmailStatus(`Sending to ${audience.length} recipient(s)...`)
    let successCount = 0
    for (const email of audience) {
      const res = await fetch(`${API}/send-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to: email, subject: emailSubject, message: emailMessage })
      })
      const data = await res.json()
      if (data.success) successCount++
    }
    await fetch(`${API}/email-history`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        subject: emailSubject,
        message: emailMessage,
        audience_type: audienceType,
        recipient_count: successCount
      })
    })
    fetch(`${API}/email-history`)
      .then(res => res.json())
      .then(data => setEmailHistory(data))
    setEmailStatus(`Sent successfully to ${successCount} recipient(s)! ✅`)
    setEmailTo('')
    setEmailToName('')
    setMemberSearch('')
    setEmailSubject('')
    setEmailMessage('')
  }

  // Character + segment count helpers for SMS.
  // GSM-7 text = 160 chars/segment; if any non-GSM char is present, switch to UCS-2 at 70 chars/segment.
  const getSmsBody = () => {
    const base = smsMessage || ''
    return includeOptOutFooter && base ? `${base.trim()} — Reply STOP to opt out` : base
  }
  const isGsm7 = (str) => /^[\u0000-\u007F\u00A3\u00A5\u00E8\u00E9\u00F2\u00E7\u00D8\u00F8\u00C5\u00E5\u0394\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039E\u00C6\u00E6\u00DF\u00C9\u00A4\u00A1\u00C4\u00D6\u00D1\u00DC\u00A7\u00BF\u00E4\u00F6\u00F1\u00FC\u00E0]*$/.test(str)
  const smsCounts = () => {
    const body = getSmsBody()
    const len = body.length
    const per = isGsm7(body) ? 160 : 70
    const segs = len === 0 ? 0 : Math.ceil(len / per)
    return { len, per, segs, unicode: !isGsm7(body) }
  }

  const sendSMS = async () => {
    const audience = getAudience('phone')
    if (audience.length === 0) {
      setSmsStatus('No recipients with phone numbers found ❌')
      return
    }
    if (!smsMessage.trim()) {
      setSmsStatus('Message is empty ❌')
      return
    }
    const body = getSmsBody()
    setSmsStatus(`Sending to ${audience.length} recipient(s)...`)
    let successCount = 0
    for (const phone of audience) {
      const res = await fetch(`${API}/send-sms`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to: phone, message: body })
      })
      const data = await res.json()
      if (data.success) successCount++
    }
    await fetch(`${API}/sms-history`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: body,
        audience_type: audienceType,
        recipient_count: successCount
      })
    })
    fetch(`${API}/sms-history`)
      .then(res => res.json())
      .then(data => setSmsHistory(data))
    setSmsStatus(`Sent successfully to ${successCount} recipient(s)! ✅`)
    setSmsTo('')
    setSmsToName('')
    setMemberSearch('')
    setSmsMessage('')
  }

  // ---- Push notifications ----
  // Fetch reach preview when audience changes and channel is push
  const refreshPushReach = async () => {
    try {
      const params = new URLSearchParams({ audience: audienceType })
      if (audienceType === 'campus') params.set('campus_id', selectedCampus || '')
      if (audienceType === 'tag') params.set('tag_id', selectedTag || '')
      if (audienceType === 'individual') params.set('member_id', selectedMember || '')
      const res = await fetch(`${API}/push-reach?${params.toString()}`)
      const data = await res.json()
      setPushReach(data)
    } catch (e) { setPushReach(null) }
  }

  const sendPush = async () => {
    if (!pushTitle.trim()) { setPushStatus('Title required ❌'); return }
    setPushStatus('Sending...')
    const payload = {
      audience: audienceType,
      title: pushTitle,
      body: pushBody,
      link: pushLink || undefined
    }
    if (audienceType === 'campus') payload.campus_id = selectedCampus
    if (audienceType === 'tag') payload.tag_id = selectedTag
    if (audienceType === 'individual') payload.member_id = selectedMember
    const res = await fetch(`${API}/send-push`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    const data = await res.json()
    if (!res.ok) {
      setPushStatus(data.error || 'Something went wrong ❌')
      return
    }
    if (data.sent === 0) {
      setPushStatus(data.message || 'Nothing was sent.')
    } else {
      setPushStatus(`Sent to ${data.sent} device(s) · ${data.member_count} member(s) ✅`)
    }
    setPushTitle(''); setPushBody(''); setPushLink('')
    fetch(`${API}/push-history`).then(r => r.json()).then(setPushHistory)
  }

  const addMember = async () => {
    const res = await fetch(`${API}/members`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newMember)
    })
    const data = await res.json()
    if (data && data[0]) {
      setMembers([...members, data[0]])
      setMemberStatus('Member added successfully! ✅')
      setNewMember({ first_name: '', last_name: '', email: '', phone: '', campus_id: '', status: 'visitor' })
      setShowAddMember(false)
    } else {
      setMemberStatus('Something went wrong ❌')
    }
  }

  const addTag = async () => {
    const res = await fetch(`${API}/tags`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newTag)
    })
    const data = await res.json()
    if (data && data[0]) {
      setTags([...tags, data[0]])
      setTagStatus('Tag created! ✅')
      setNewTag({ name: '', color: '#1F3D34' })
    } else {
      setTagStatus('Something went wrong ❌')
    }
  }

  const loadMemberTags = async (memberId) => {
    const res = await fetch(`${API}/member-tags/${memberId}`)
    const data = await res.json()
    setMemberTags(prev => ({ ...prev, [memberId]: data.map(mt => mt.tags) }))
  }

  const assignTag = async () => {
    if (!selectedMember || !selectedTagToAdd) return
    const res = await fetch(`${API}/member-tags`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ member_id: selectedMember, tag_id: selectedTagToAdd })
    })
    const data = await res.json()
    if (data && data[0]) {
      loadMemberTags(selectedMember)
      setSelectedTagToAdd('')
    }
  }

  const savePost = async (status) => {
    const res = await fetch(`${API}/posts`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...newPost, status })
    })
    const data = await res.json()
    if (data && data[0]) {
      setPosts([data[0], ...posts])
      setPostStatus(status === 'published' ? 'Post published! ✅' : 'Draft saved! ✅')
      setNewPost({ title: '', body: '', campus_id: '', category: 'announcement', image_url: '', status: 'draft' })
    } else {
      setPostStatus('Something went wrong ❌')
    }
  }

  const deletePost = async (id) => {
    if (!window.confirm('Delete this post?')) return
    await fetch(`${API}/posts/${id}`, { method: 'DELETE' })
    setPosts(posts.filter(p => p.id !== id))
  }

  const startEditPost = (post) => {
    setEditingPostId(post.id)
    setNewPost({
      title: post.title || '',
      body: post.body || '',
      campus_id: post.campus_id || '',
      category: post.category || 'announcement',
      image_url: post.image_url || '',
      status: post.status || 'draft'
    })
  }

  const cancelEditPost = () => {
    setEditingPostId(null)
    setNewPost({ title: '', body: '', campus_id: '', category: 'announcement', image_url: '', status: 'draft' })
    setPostStatus('')
  }

  const updatePost = async (status) => {
    if (!editingPostId) return
    const res = await fetch(`${API}/posts/${editingPostId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...newPost, status })
    })
    const data = await res.json()
    if (Array.isArray(data) && data[0]) {
      setPosts(posts.map(p => p.id === editingPostId ? data[0] : p))
      setPostStatus(status === 'published' ? 'Post published! ✅' : 'Post updated! ✅')
      cancelEditPost()
    } else {
      setPostStatus('Something went wrong ❌')
    }
  }

  // ---- Member edit / delete ----
  const startEditMember = (m) => {
    setEditingMemberId(m.id)
    setMemberDraft({
      first_name: m.first_name || '',
      last_name: m.last_name || '',
      email: m.email || '',
      phone: m.phone || '',
      campus_id: m.campus_id || '',
      status: m.status || 'visitor'
    })
  }

  const cancelEditMember = () => {
    setEditingMemberId(null)
    setMemberDraft({})
  }

  const saveEditMember = async () => {
    const res = await fetch(`${API}/members/${editingMemberId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(memberDraft)
    })
    const data = await res.json()
    if (data && data.id) {
      setMembers(members.map(m => m.id === data.id ? data : m))
      setMemberStatus('Member updated ✅')
      cancelEditMember()
    } else {
      setMemberStatus('Something went wrong ❌')
    }
  }

  const openMemberDetail = async (m) => {
    setMemberDetailId(m.id);
    setMemberDetail(null);
    try {
      const res = await fetch(`${API}/members/${m.id}/profile`);
      const data = await res.json();
      setMemberDetail(data);
    } catch (e) { setMemberDetail({ error: e.message }); }
  };
  const closeMemberDetail = () => { setMemberDetailId(null); setMemberDetail(null); };

  // Quick actions from member detail
  const quickEmailMember = (m) => {
    setActiveTab('communications');
    setCommsChannel('email');
    setAudienceType('individual');
    setEmailTo(m.email || '');
    setEmailToName(`${m.first_name || ''} ${m.last_name || ''}`.trim());
    closeMemberDetail();
  };
  const quickSmsMember = (m) => {
    setActiveTab('communications');
    setCommsChannel('sms');
    setAudienceType('individual');
    setSmsTo(m.phone || '');
    setSmsToName(`${m.first_name || ''} ${m.last_name || ''}`.trim());
    closeMemberDetail();
  };

  const deleteMember = async (m) => {
    if (!window.confirm(`Delete ${m.first_name} ${m.last_name}? This also removes their tags.`)) return
    const res = await fetch(`${API}/members/${m.id}`, { method: 'DELETE' })
    const data = await res.json()
    if (data.success) {
      setMembers(members.filter(x => x.id !== m.id))
      setMemberStatus('Member deleted ✅')
    } else {
      setMemberStatus('Something went wrong ❌')
    }
  }

  // ---- Campus CRUD ----
  const addCampus = async () => {
    if (!newCampus.name.trim()) {
      setCampusStatus('Campus name is required ❌')
      return
    }
    const res = await fetch(`${API}/campuses`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newCampus)
    })
    const data = await res.json()
    if (data && data.id) {
      setCampuses([...campuses, data])
      setCampusStatus('Campus added ✅')
      setNewCampus({ name: '', city: '', lat: '', lng: '' })
      setShowAddCampus(false)
    } else {
      setCampusStatus('Something went wrong ❌')
    }
  }

  const startEditCampus = (c) => {
    setEditingCampusId(c.id)
    setCampusDraft({
      name: c.name || '',
      city: c.city || '',
      lat: c.lat ?? '',
      lng: c.lng ?? ''
    })
  }

  const cancelEditCampus = () => {
    setEditingCampusId(null)
    setCampusDraft({})
  }

  const saveEditCampus = async () => {
    const res = await fetch(`${API}/campuses/${editingCampusId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(campusDraft)
    })
    const data = await res.json()
    if (data && data.id) {
      setCampuses(campuses.map(c => c.id === data.id ? data : c))
      setCampusStatus('Campus updated ✅')
      cancelEditCampus()
    } else {
      setCampusStatus('Something went wrong ❌')
    }
  }

  const deleteCampus = async (c) => {
    if (!window.confirm(`Delete ${c.name}? Members currently assigned to this campus will become unassigned.`)) return
    const res = await fetch(`${API}/campuses/${c.id}`, { method: 'DELETE' })
    const data = await res.json()
    if (data.success) {
      setCampuses(campuses.filter(x => x.id !== c.id))
      setCampusStatus('Campus deleted ✅')
    } else {
      setCampusStatus('Something went wrong ❌')
    }
  }

  // ---- Tag edit / delete ----
  const startEditTag = (t) => {
    setEditingTagId(t.id)
    setTagDraft({ name: t.name || '', color: t.color || '#1F3D34' })
  }

  const cancelEditTag = () => {
    setEditingTagId(null)
    setTagDraft({ name: '', color: '#1F3D34' })
  }

  const saveEditTag = async () => {
    const res = await fetch(`${API}/tags/${editingTagId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(tagDraft)
    })
    const data = await res.json()
    if (data && data.id) {
      setTags(tags.map(x => x.id === data.id ? data : x))
      setTagStatus('Tag updated ✅')
      cancelEditTag()
    } else {
      setTagStatus('Something went wrong ❌')
    }
  }

  // ---- Events ----
  const refreshEvents = async () => {
    const res = await fetch(`${API}/events?status=all&when=all`);
    const data = await res.json();
    setEvents(data);
  };

  const openNewEvent = () => {
    setEditingEventId(null);
    setEventDraft(emptyEvent);
    setShowEventForm(true);
    setEventStatus('');
  };

  const openEditEvent = (e) => {
    setEditingEventId(e.id);
    // Convert ISO → local input format for datetime-local fields
    const toLocalInput = (iso) => {
      if (!iso) return '';
      const d = new Date(iso);
      const tz = d.getTimezoneOffset() * 60000;
      return new Date(d - tz).toISOString().slice(0, 16);
    };
    setEventDraft({
      title: e.title || '',
      description: e.description || '',
      start_at: toLocalInput(e.start_at),
      end_at: toLocalInput(e.end_at),
      location: e.location || '',
      campus_id: e.campus_id || '',
      category: e.category || 'community',
      capacity: e.capacity ?? '',
      image_url: e.image_url || '',
      registration_open: e.registration_open !== false,
      status: e.status || 'draft'
    });
    setShowEventForm(true);
    setEventStatus('');
  };

  const saveEvent = async (overrideStatus) => {
    if (!eventDraft.title.trim()) { setEventStatus('Title is required ❌'); return; }
    if (!eventDraft.start_at) { setEventStatus('Start date/time is required ❌'); return; }
    const payload = {
      ...eventDraft,
      start_at: new Date(eventDraft.start_at).toISOString(),
      end_at: eventDraft.end_at ? new Date(eventDraft.end_at).toISOString() : null,
      capacity: eventDraft.capacity === '' ? null : parseInt(eventDraft.capacity),
      campus_id: eventDraft.campus_id === '' ? null : eventDraft.campus_id,
      status: overrideStatus || eventDraft.status
    };
    const url = editingEventId ? `${API}/events/${editingEventId}` : `${API}/events`;
    const method = editingEventId ? 'PATCH' : 'POST';
    const res = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (data && data.id) {
      await refreshEvents();
      setEventStatus(editingEventId ? 'Event updated ✅' : 'Event created ✅');
      setShowEventForm(false);
      setEditingEventId(null);
      setEventDraft(emptyEvent);
    } else {
      setEventStatus(data?.error ? `Error: ${data.error}` : 'Something went wrong ❌');
    }
  };

  const deleteEvent = async (e) => {
    if (!window.confirm(`Delete "${e.title}"? This also removes all registrations for it.`)) return;
    const res = await fetch(`${API}/events/${e.id}`, { method: 'DELETE' });
    const data = await res.json();
    if (data.success) {
      setEvents(events.filter(x => x.id !== e.id));
      if (selectedEventId === e.id) { setSelectedEventId(null); setRegistrations([]); }
    }
  };

  const openEventRoster = async (e) => {
    setSelectedEventId(e.id);
    const res = await fetch(`${API}/events/${e.id}/registrations`);
    const data = await res.json();
    setRegistrations(data);
  };

  const closeEventRoster = () => {
    setSelectedEventId(null);
    setRegistrations([]);
    setRosterSearch('');
  };

  const updateRegistration = async (regId, patch) => {
    const res = await fetch(`${API}/events/${selectedEventId}/registrations/${regId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(patch)
    });
    const data = await res.json();
    if (data && data.id) {
      setRegistrations(registrations.map(r => r.id === regId ? data : r));
    }
  };

  const removeRegistration = async (regId) => {
    if (!window.confirm('Remove this registration?')) return;
    const res = await fetch(`${API}/events/${selectedEventId}/registrations/${regId}`, { method: 'DELETE' });
    const data = await res.json();
    if (data.success) setRegistrations(registrations.filter(r => r.id !== regId));
  };

  const exportRosterCSV = () => {
    const rows = [
      ['Name', 'Email', 'Phone', 'Guests', 'Status', 'Registered At', 'Notes'],
      ...registrations.map(r => [
        r.name || '',
        r.email || '',
        r.phone || '',
        r.guests_count || 1,
        r.status || '',
        new Date(r.registered_at).toLocaleString(),
        (r.notes || '').replace(/"/g, '""')
      ])
    ];
    const csv = rows
      .map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
      .join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const eventTitle = events.find(e => e.id === selectedEventId)?.title || 'event';
    a.href = url;
    a.download = `${eventTitle.replace(/[^a-z0-9]+/gi, '_')}_roster.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const filteredEvents = (() => {
    const now = new Date();
    if (eventsFilter === 'upcoming') return events.filter(e => new Date(e.start_at) >= now);
    if (eventsFilter === 'past') return events.filter(e => new Date(e.start_at) < now);
    return events;
  })();

  const filteredRegistrations = registrations.filter(r =>
    !rosterSearch ||
    `${r.name} ${r.email || ''} ${r.phone || ''}`.toLowerCase().includes(rosterSearch.toLowerCase())
  );

  const selectedEvent = events.find(e => e.id === selectedEventId);

  // ---- Sermons ----
  const refreshSermons = async () => {
    const res = await fetch(`${API}/sermons?status=all`);
    const data = await res.json();
    setSermons(data);
  };

  const openNewSermon = () => {
    setEditingSermonId(null);
    setSermonDraft(emptySermon);
    setShowSermonForm(true);
    setSermonStatus('');
  };

  const openEditSermon = (s) => {
    setEditingSermonId(s.id);
    const toLocalInput = (iso) => {
      if (!iso) return '';
      const d = new Date(iso);
      const tz = d.getTimezoneOffset() * 60000;
      return new Date(d - tz).toISOString().slice(0, 16);
    };
    setSermonDraft({
      title: s.title || '',
      description: s.description || '',
      series: s.series || '',
      speaker: s.speaker || '',
      scripture_reference: s.scripture_reference || '',
      video_url: s.video_url || '',
      audio_url: s.audio_url || '',
      thumbnail_url: s.thumbnail_url || '',
      duration_seconds: s.duration_seconds ?? '',
      campus_id: s.campus_id || '',
      preached_at: toLocalInput(s.preached_at),
      status: s.status || 'draft'
    });
    setShowSermonForm(true);
    setSermonStatus('');
  };

  const saveSermon = async (overrideStatus) => {
    if (!sermonDraft.title.trim()) { setSermonStatus('Title is required ❌'); return; }
    const payload = {
      ...sermonDraft,
      duration_seconds: sermonDraft.duration_seconds === '' ? null : parseInt(sermonDraft.duration_seconds),
      preached_at: sermonDraft.preached_at ? new Date(sermonDraft.preached_at).toISOString() : null,
      campus_id: sermonDraft.campus_id === '' ? null : sermonDraft.campus_id,
      status: overrideStatus || sermonDraft.status
    };
    const url = editingSermonId ? `${API}/sermons/${editingSermonId}` : `${API}/sermons`;
    const method = editingSermonId ? 'PATCH' : 'POST';
    const res = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    const data = await res.json();
    if (data && data.id) {
      await refreshSermons();
      setSermonStatus(editingSermonId ? 'Sermon updated ✅' : 'Sermon added ✅');
      setShowSermonForm(false);
      setEditingSermonId(null);
      setSermonDraft(emptySermon);
    } else {
      setSermonStatus(data?.error ? `Error: ${data.error}` : 'Something went wrong ❌');
    }
  };

  const deleteSermon = async (s) => {
    if (!window.confirm(`Delete "${s.title}"?`)) return;
    const res = await fetch(`${API}/sermons/${s.id}`, { method: 'DELETE' });
    const data = await res.json();
    if (data.success) setSermons(sermons.filter(x => x.id !== s.id));
  };

  // ---- Groups ----
  const refreshGroups = async () => {
    const res = await fetch(`${API}/groups?status=all`); const data = await res.json(); setGroups(data);
  };

  const openNewGroup = () => {
    setEditingGroupId(null); setGroupDraft(emptyGroup); setShowGroupForm(true); setGroupStatus('');
  };

  const openEditGroup = (g) => {
    setEditingGroupId(g.id);
    setGroupDraft({
      name: g.name || '', description: g.description || '',
      category: g.category || 'small_group',
      meeting_day: g.meeting_day || '', meeting_time: g.meeting_time || '',
      location: g.location || '', leader_name: g.leader_name || '',
      leader_contact: g.leader_contact || '', image_url: g.image_url || '',
      capacity: g.capacity ?? '', campus_id: g.campus_id || '',
      status: g.status || 'draft'
    });
    setShowGroupForm(true); setGroupStatus('');
  };

  const saveGroup = async (overrideStatus) => {
    if (!groupDraft.name.trim()) { setGroupStatus('Name is required ❌'); return; }
    const payload = {
      ...groupDraft,
      capacity: groupDraft.capacity === '' ? null : parseInt(groupDraft.capacity),
      campus_id: groupDraft.campus_id === '' ? null : groupDraft.campus_id,
      status: overrideStatus || groupDraft.status
    };
    const url = editingGroupId ? `${API}/groups/${editingGroupId}` : `${API}/groups`;
    const method = editingGroupId ? 'PATCH' : 'POST';
    const res = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    const data = await res.json();
    if (data && data.id) {
      await refreshGroups();
      setGroupStatus(editingGroupId ? 'Group updated ✅' : 'Group created ✅');
      setShowGroupForm(false); setEditingGroupId(null); setGroupDraft(emptyGroup);
    } else {
      setGroupStatus(data?.error ? `Error: ${data.error}` : 'Something went wrong ❌');
    }
  };

  const deleteGroup = async (g) => {
    if (!window.confirm(`Delete "${g.name}"? All member memberships will be removed.`)) return;
    const res = await fetch(`${API}/groups/${g.id}`, { method: 'DELETE' });
    const data = await res.json();
    if (data.success) setGroups(groups.filter(x => x.id !== g.id));
  };

  const openGroupRoster = async (g) => {
    setSelectedGroupId(g.id);
    const res = await fetch(`${API}/groups/${g.id}/members`);
    const data = await res.json();
    setGroupRoster(data);
  };

  const closeGroupRoster = () => { setSelectedGroupId(null); setGroupRoster([]); };

  const removeGroupMember = async (memberId) => {
    if (!window.confirm('Remove this member from the group?')) return;
    const res = await fetch(`${API}/groups/${selectedGroupId}/members/${memberId}`, { method: 'DELETE' });
    const data = await res.json();
    if (data.success) setGroupRoster(groupRoster.filter(r => r.member_id !== memberId));
  };

  const selectedGroup = groups.find(g => g.id === selectedGroupId);

  // ---- Devotionals ----
  const refreshDevos = async () => {
    const res = await fetch(`${API}/devotionals?status=all`);
    const data = await res.json();
    setDevotionals(data);
  };

  const openNewDevo = () => {
    setEditingDevoId(null);
    setDevoDraft({ ...emptyDevo, available_on: new Date().toISOString().slice(0, 10) });
    setShowDevoForm(true);
    setDevoStatus('');
  };

  const openEditDevo = (d) => {
    setEditingDevoId(d.id);
    setDevoDraft({
      title: d.title || '',
      body: d.body || '',
      scripture_reference: d.scripture_reference || '',
      scripture_text: d.scripture_text || '',
      reflection_question: d.reflection_question || '',
      author: d.author || '',
      image_url: d.image_url || '',
      available_on: d.available_on || '',
      series: d.series || '',
      status: d.status || 'draft'
    });
    setShowDevoForm(true);
    setDevoStatus('');
  };

  const saveDevo = async (overrideStatus) => {
    if (!devoDraft.title.trim()) { setDevoStatus('Title is required ❌'); return; }
    if (!devoDraft.body.trim()) { setDevoStatus('Body is required ❌'); return; }
    const payload = {
      ...devoDraft,
      available_on: devoDraft.available_on || null,
      status: overrideStatus || devoDraft.status
    };
    const url = editingDevoId ? `${API}/devotionals/${editingDevoId}` : `${API}/devotionals`;
    const method = editingDevoId ? 'PATCH' : 'POST';
    const res = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    const data = await res.json();
    if (data && data.id) {
      await refreshDevos();
      setDevoStatus(editingDevoId ? 'Devotional updated ✅' : 'Devotional added ✅');
      setShowDevoForm(false);
      setEditingDevoId(null);
      setDevoDraft(emptyDevo);
    } else {
      setDevoStatus(data?.error ? `Error: ${data.error}` : 'Something went wrong ❌');
    }
  };

  const deleteDevo = async (d) => {
    if (!window.confirm(`Delete "${d.title}"?`)) return;
    const res = await fetch(`${API}/devotionals/${d.id}`, { method: 'DELETE' });
    const data = await res.json();
    if (data.success) setDevotionals(devotionals.filter(x => x.id !== d.id));
  };

  // ---- Tag delete (existing) ----
  const deleteTag = async (t) => {
    if (!window.confirm(`Delete tag "${t.name}"? It will be removed from all members.`)) return
    const res = await fetch(`${API}/tags/${t.id}`, { method: 'DELETE' })
    const data = await res.json()
    if (data.success) {
      setTags(tags.filter(x => x.id !== t.id))
      setTagStatus('Tag deleted ✅')
    } else {
      setTagStatus('Something went wrong ❌')
    }
  }

  const getCampusName = (id) => {
    const campus = campuses.find(c => c.id === parseInt(id))
    return campus ? campus.name : 'All Campuses'
  }

  if (!session) {
    return (
      <div className="login-screen">
        <div className="login-box">
          <h1>ChurchOS<span className="logo-dot">.</span></h1>
          <p style={{color: 'var(--text-muted)', marginBottom: 16, fontSize: 14}}>Sign in to your dashboard</p>
          <input
            type="email"
            placeholder="Email"
            value={loginEmail}
            onChange={e => setLoginEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            value={loginPassword}
            onChange={e => setLoginPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && login()}
          />
          {loginError && <p style={{color: 'var(--danger)', fontSize: 14, fontWeight: 500}}>{loginError}</p>}
          <button onClick={login} className="send-btn">Sign In</button>
        </div>
      </div>
    )
  }

  return (
    <div className="app">
      <div className="sidebar">
        <h1 className="logo">ChurchOS<span className="logo-dot">.</span></h1>
        <nav>
          <button onClick={() => setActiveTab('dashboard')} className={activeTab === 'dashboard' ? 'active' : ''}>Dashboard</button>
          <button onClick={() => setActiveTab('analytics')} className={activeTab === 'analytics' ? 'active' : ''}>Analytics</button>
          <button onClick={() => setActiveTab('members')} className={activeTab === 'members' ? 'active' : ''}>Members</button>
          <button onClick={() => setActiveTab('campuses')} className={activeTab === 'campuses' ? 'active' : ''}>Campuses</button>
          <button onClick={() => setActiveTab('events')} className={activeTab === 'events' ? 'active' : ''}>Events</button>
          <button onClick={() => setActiveTab('groups')} className={activeTab === 'groups' ? 'active' : ''}>Groups</button>
          <button onClick={() => setActiveTab('sermons')} className={activeTab === 'sermons' ? 'active' : ''}>Sermons</button>
          <button onClick={() => setActiveTab('devotionals')} className={activeTab === 'devotionals' ? 'active' : ''}>Devotionals</button>
          <button onClick={() => setActiveTab('tags')} className={activeTab === 'tags' ? 'active' : ''}>Tags</button>
          <button onClick={() => setActiveTab('content')} className={activeTab === 'content' ? 'active' : ''}>Content Studio</button>
          <button onClick={() => setActiveTab('communications')} className={activeTab === 'communications' ? 'active' : ''}>Communications</button>
        </nav>
        <button onClick={logout} className="logout-btn">Sign Out</button>
      </div>

      <div className="main">
        {activeTab === 'dashboard' && (
          <div>
            <h2>Welcome back, Autumn 👋</h2>
            <div className="stats">
              <div className="stat-card">
                <h3>{stats?.totalMembers || 0}</h3>
                <p>Total Members</p>
              </div>
              <div className="stat-card">
                <h3>{stats?.totalCampuses || 0}</h3>
                <p>Campuses</p>
              </div>
              <div className="stat-card">
                <h3>{stats?.totalTags || 0}</h3>
                <p>Tags</p>
              </div>
              <div className="stat-card">
                <h3>{posts.filter(p => p.status === 'published').length}</h3>
                <p>Live Posts</p>
              </div>
              {stats?.topCampus && (
                <div className="stat-card">
                  <h3>{stats.topCampus.name}</h3>
                  <p>Most Members ({stats.topCampus.count})</p>
                </div>
              )}
            </div>
            {stats?.statusCounts && (
              <div className="status-breakdown">
                <h3>Members by Status</h3>
                <div className="status-grid">
                  {Object.entries(stats.statusCounts).map(([status, count]) => (
                    <div key={status} className="status-card">
                      <h4>{count}</h4>
                      <p>{status.charAt(0).toUpperCase() + status.slice(1)}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'members' && (
          <div>
            <div className="tab-header">
              <h2>Members</h2>
              <button className="send-btn" onClick={() => setShowAddMember(!showAddMember)}>
                {showAddMember ? 'Cancel' : '+ Add Member'}
              </button>
            </div>
            {memberStatus && <p className="status">{memberStatus}</p>}
            {showAddMember && (
              <div className="comm-form" style={{marginBottom: '24px'}}>
                <h3>New Member</h3>
                <div className="form-row">
                  <input type="text" placeholder="First Name" value={newMember.first_name} onChange={e => setNewMember({...newMember, first_name: e.target.value})} />
                  <input type="text" placeholder="Last Name" value={newMember.last_name} onChange={e => setNewMember({...newMember, last_name: e.target.value})} />
                </div>
                <input type="text" placeholder="Email" value={newMember.email} onChange={e => setNewMember({...newMember, email: e.target.value})} />
                <input type="text" placeholder="Phone" value={newMember.phone} onChange={e => setNewMember({...newMember, phone: e.target.value})} />
                <select value={newMember.campus_id} onChange={e => setNewMember({...newMember, campus_id: e.target.value})}>
                  <option value="">Select Campus...</option>
                  {campuses.map(campus => <option key={campus.id} value={campus.id}>{campus.name}</option>)}
                </select>
                <select value={newMember.status} onChange={e => setNewMember({...newMember, status: e.target.value})}>
                  <option value="visitor">Visitor</option>
                  <option value="member">Member</option>
                  <option value="volunteer">Volunteer</option>
                  <option value="staff">Staff</option>
                </select>
                <button onClick={addMember} className="send-btn">Save Member</button>
              </div>
            )}
            <table>
              <thead>
                <tr>
                  <th>Name</th><th>Email</th><th>Phone</th><th>Campus</th><th>Status</th><th>Tags</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {members.map(member => editingMemberId === member.id ? (
                  <tr key={member.id} className="member-edit-row">
                    <td>
                      <input type="text" placeholder="First" value={memberDraft.first_name} onChange={e => setMemberDraft({...memberDraft, first_name: e.target.value})} style={{marginBottom: '4px'}} />
                      <input type="text" placeholder="Last" value={memberDraft.last_name} onChange={e => setMemberDraft({...memberDraft, last_name: e.target.value})} />
                    </td>
                    <td><input type="text" value={memberDraft.email} onChange={e => setMemberDraft({...memberDraft, email: e.target.value})} /></td>
                    <td><input type="text" value={memberDraft.phone} onChange={e => setMemberDraft({...memberDraft, phone: e.target.value})} /></td>
                    <td>
                      <select value={memberDraft.campus_id || ''} onChange={e => setMemberDraft({...memberDraft, campus_id: e.target.value})}>
                        <option value="">—</option>
                        {campuses.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                      </select>
                    </td>
                    <td>
                      <select value={memberDraft.status} onChange={e => setMemberDraft({...memberDraft, status: e.target.value})}>
                        <option value="visitor">Visitor</option>
                        <option value="member">Member</option>
                        <option value="volunteer">Volunteer</option>
                        <option value="staff">Staff</option>
                      </select>
                    </td>
                    <td>—</td>
                    <td>
                      <div className="row-actions">
                        <button onClick={saveEditMember} className="icon-btn icon-save" title="Save">✓</button>
                        <button onClick={cancelEditMember} className="icon-btn" title="Cancel">✕</button>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr key={member.id} className="member-row-clickable">
                    <td onClick={() => openMemberDetail(member)} style={{cursor: 'pointer'}}>{member.first_name} {member.last_name}</td>
                    <td onClick={() => openMemberDetail(member)} style={{cursor: 'pointer'}}>{member.email}</td>
                    <td onClick={() => openMemberDetail(member)} style={{cursor: 'pointer'}}>{member.phone}</td>
                    <td onClick={() => openMemberDetail(member)} style={{cursor: 'pointer'}}>{campuses.find(c => c.id === member.campus_id)?.name || '—'}</td>
                    <td onClick={() => openMemberDetail(member)} style={{cursor: 'pointer'}}>{member.status}</td>
                    <td>
                      <div className="member-tags-cell">
                        {(memberTags[member.id] || []).map(tag => tag && (
                          <span key={tag.id} className="tag-pill" style={{background: tag.color}}>{tag.name}</span>
                        ))}
                        {selectedMember === member.id ? (
                          <div className="tag-assign">
                            <select value={selectedTagToAdd} onChange={e => setSelectedTagToAdd(e.target.value)}>
                              <option value="">Add tag...</option>
                              {tags.map(tag => <option key={tag.id} value={tag.id}>{tag.name}</option>)}
                            </select>
                            <button onClick={assignTag} className="tag-add-btn">✓</button>
                            <button onClick={() => setSelectedMember(null)} className="tag-add-btn">✕</button>
                          </div>
                        ) : (
                          <button onClick={() => setSelectedMember(member.id)} className="tag-add-btn">+</button>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="row-actions">
                        <button onClick={() => startEditMember(member)} className="icon-btn" title="Edit">✎</button>
                        <button onClick={() => deleteMember(member)} className="icon-btn icon-danger" title="Delete">🗑</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {memberDetailId && (
          <div className="member-detail-backdrop" onClick={closeMemberDetail}>
            <div className="member-detail" onClick={e => e.stopPropagation()}>
              <button className="member-detail-close" onClick={closeMemberDetail}>✕</button>
              {!memberDetail ? (
                <div style={{padding: 60, textAlign: 'center', color: 'var(--text-muted)'}}>Loading member…</div>
              ) : memberDetail.error ? (
                <div style={{padding: 60, textAlign: 'center', color: 'var(--danger)'}}>{memberDetail.error}</div>
              ) : (
                <>
                  <div className="member-detail-header">
                    <div className="member-detail-avatar">
                      {((memberDetail.member.first_name?.[0] || '') + (memberDetail.member.last_name?.[0] || '')).toUpperCase() || '?'}
                    </div>
                    <div className="member-detail-id">
                      <h2>{memberDetail.member.first_name} {memberDetail.member.last_name}</h2>
                      <p className="member-detail-meta">
                        {memberDetail.member.status} · {getCampusName(memberDetail.member.campus_id) || '—'}
                      </p>
                      <div className="member-detail-tags">
                        {(memberDetail.tags || []).map(t => (
                          <span key={t.id} className="tag-pill" style={{background: t.color}}>{t.name}</span>
                        ))}
                      </div>
                    </div>
                    <div className="member-detail-actions">
                      {memberDetail.member.email && (
                        <button className="icon-btn" onClick={() => quickEmailMember(memberDetail.member)}>✉️ Email</button>
                      )}
                      {memberDetail.member.phone && (
                        <button className="icon-btn" onClick={() => quickSmsMember(memberDetail.member)}>💬 SMS</button>
                      )}
                      <button className="icon-btn" onClick={() => { closeMemberDetail(); startEditMember(memberDetail.member); }}>✎ Edit</button>
                    </div>
                  </div>

                  <div className="member-detail-grid">
                    <div className="member-detail-section">
                      <h3>Contact</h3>
                      <div className="kv-row"><span className="kv-label">Email</span><span className="kv-value">{memberDetail.member.email || '—'}</span></div>
                      <div className="kv-row"><span className="kv-label">Phone</span><span className="kv-value">{memberDetail.member.phone || '—'}</span></div>
                      <div className="kv-row"><span className="kv-label">Joined</span><span className="kv-value">{memberDetail.member.created_at ? new Date(memberDetail.member.created_at).toLocaleDateString() : '—'}</span></div>
                    </div>

                    <div className="member-detail-section">
                      <h3>Engagement</h3>
                      <div className="kv-row"><span className="kv-label">🔥 Streak</span><span className="kv-value">{memberDetail.devotional_streak} days</span></div>
                      <div className="kv-row"><span className="kv-label">Devos completed</span><span className="kv-value">{memberDetail.devotional_total}</span></div>
                      <div className="kv-row"><span className="kv-label">Events RSVP'd</span><span className="kv-value">{memberDetail.registrations.filter(r => r.status !== 'cancelled').length}</span></div>
                      <div className="kv-row"><span className="kv-label">Groups</span><span className="kv-value">{memberDetail.groups.length}</span></div>
                    </div>
                  </div>

                  {memberDetail.registrations.length > 0 && (
                    <div className="member-detail-section">
                      <h3>Event Registrations</h3>
                      {memberDetail.registrations.slice(0, 8).map(r => r.events && (
                        <div key={r.id} className="member-detail-row">
                          <div>
                            <div className="row-title">{r.events.title}</div>
                            <div className="row-meta">{new Date(r.events.start_at).toLocaleDateString()} · {r.events.location || '—'}</div>
                          </div>
                          <span className={`post-status-badge ${r.status === 'cancelled' ? 'cancelled' : r.status === 'waitlist' ? 'draft' : 'published'}`}>
                            {r.status}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}

                  {memberDetail.groups.length > 0 && (
                    <div className="member-detail-section">
                      <h3>Groups</h3>
                      {memberDetail.groups.map(g => g.groups && (
                        <div key={g.id} className="member-detail-row">
                          <div>
                            <div className="row-title">{g.groups.name}</div>
                            <div className="row-meta">{g.groups.meeting_day} {g.groups.meeting_time}</div>
                          </div>
                          <span className="post-status-badge published">{g.role}</span>
                        </div>
                      ))}
                    </div>
                  )}

                  {memberDetail.activity.length > 0 && (
                    <div className="member-detail-section">
                      <h3>Recent Activity</h3>
                      <div className="activity-timeline">
                        {memberDetail.activity.slice(0, 20).map(a => (
                          <div key={a.id} className="activity-row">
                            <span className="activity-time">{new Date(a.created_at).toLocaleString('en-US', {month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit'})}</span>
                            <span className="activity-type">{a.event_type.replace(/_/g, ' ')}</span>
                            {a.subject_id && <span className="activity-subject">{a.subject_id}</span>}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}

        {activeTab === 'campuses' && (
          <div>
            <div className="tab-header">
              <h2>Campuses</h2>
              <button className="send-btn" onClick={() => setShowAddCampus(!showAddCampus)}>
                {showAddCampus ? 'Cancel' : '+ Add Campus'}
              </button>
            </div>
            {campusStatus && <p className="status">{campusStatus}</p>}
            {showAddCampus && (
              <div className="comm-form" style={{marginBottom: '24px'}}>
                <h3>New Campus</h3>
                <input type="text" placeholder="Campus name (e.g. Granbury)" value={newCampus.name} onChange={e => setNewCampus({...newCampus, name: e.target.value})} />
                <input type="text" placeholder="City" value={newCampus.city} onChange={e => setNewCampus({...newCampus, city: e.target.value})} />
                <div className="form-row">
                  <input type="number" step="0.0001" placeholder="Latitude (for 'find nearest')" value={newCampus.lat} onChange={e => setNewCampus({...newCampus, lat: e.target.value})} />
                  <input type="number" step="0.0001" placeholder="Longitude" value={newCampus.lng} onChange={e => setNewCampus({...newCampus, lng: e.target.value})} />
                </div>
                <button onClick={addCampus} className="send-btn">Save Campus</button>
              </div>
            )}
            <div className="campus-grid">
              {campuses.map(campus => editingCampusId === campus.id ? (
                <div key={campus.id} className="campus-card campus-edit">
                  <input type="text" value={campusDraft.name} onChange={e => setCampusDraft({...campusDraft, name: e.target.value})} placeholder="Campus name" />
                  <input type="text" value={campusDraft.city} onChange={e => setCampusDraft({...campusDraft, city: e.target.value})} placeholder="City" />
                  <div className="form-row">
                    <input type="number" step="0.0001" value={campusDraft.lat} onChange={e => setCampusDraft({...campusDraft, lat: e.target.value})} placeholder="Lat" />
                    <input type="number" step="0.0001" value={campusDraft.lng} onChange={e => setCampusDraft({...campusDraft, lng: e.target.value})} placeholder="Lng" />
                  </div>
                  <div className="row-actions">
                    <button onClick={saveEditCampus} className="icon-btn icon-save">Save</button>
                    <button onClick={cancelEditCampus} className="icon-btn">Cancel</button>
                  </div>
                </div>
              ) : (
                <div key={campus.id} className="campus-card">
                  <div className="campus-card-header">
                    <h3>{campus.name}</h3>
                    <div className="row-actions">
                      <button onClick={() => startEditCampus(campus)} className="icon-btn" title="Edit">✎</button>
                      <button onClick={() => deleteCampus(campus)} className="icon-btn icon-danger" title="Delete">🗑</button>
                    </div>
                  </div>
                  <p>{campus.city}</p>
                  {(campus.lat || campus.lng) && (
                    <p className="campus-coords">{campus.lat?.toFixed?.(4) ?? campus.lat}, {campus.lng?.toFixed?.(4) ?? campus.lng}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'tags' && (
          <div>
            <div className="tab-header"><h2>Tags</h2></div>
            <div className="comm-form" style={{marginBottom: '24px'}}>
              <h3>Create New Tag</h3>
              <div className="form-row">
                <input type="text" placeholder="Tag name (e.g. Volunteer)" value={newTag.name} onChange={e => setNewTag({...newTag, name: e.target.value})} />
                <input type="color" value={newTag.color} onChange={e => setNewTag({...newTag, color: e.target.value})} />
              </div>
              <button onClick={addTag} className="send-btn">Create Tag</button>
              {tagStatus && <p className="status">{tagStatus}</p>}
            </div>
            <div className="tag-grid">
              {tags.map(tag => editingTagId === tag.id ? (
                <div key={tag.id} className="tag-card tag-edit" style={{borderLeft: `4px solid ${tagDraft.color}`}}>
                  <input type="text" value={tagDraft.name} onChange={e => setTagDraft({...tagDraft, name: e.target.value})} />
                  <input type="color" value={tagDraft.color} onChange={e => setTagDraft({...tagDraft, color: e.target.value})} />
                  <button onClick={saveEditTag} className="icon-btn icon-save" title="Save">✓</button>
                  <button onClick={cancelEditTag} className="icon-btn" title="Cancel">✕</button>
                </div>
              ) : (
                <div key={tag.id} className="tag-card" style={{borderLeft: `4px solid ${tag.color}`}}>
                  <span className="tag-dot" style={{background: tag.color}}></span>
                  <span className="tag-name">{tag.name}</span>
                  <div className="row-actions tag-actions">
                    <button onClick={() => startEditTag(tag)} className="icon-btn" title="Edit">✎</button>
                    <button onClick={() => deleteTag(tag)} className="icon-btn icon-danger" title="Delete">🗑</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'content' && (
          <div>
            <h2>Content Studio</h2>
            <div className="content-studio">
              <div className="studio-editor">
                <div className="comm-form">
                  <div className="tab-header" style={{marginBottom: '0'}}>
                    <h3>{editingPostId ? 'Edit Post' : 'Create Post'}</h3>
                    {editingPostId && (
                      <button onClick={cancelEditPost} className="icon-btn">Cancel edit</button>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder="Post title..."
                    value={newPost.title}
                    onChange={e => setNewPost({...newPost, title: e.target.value})}
                  />
                  <textarea
                    placeholder="Write your message here..."
                    value={newPost.body}
                    onChange={e => setNewPost({...newPost, body: e.target.value})}
                    style={{height: '200px'}}
                  />
                  <select value={newPost.campus_id} onChange={e => setNewPost({...newPost, campus_id: e.target.value})}>
                    <option value="">All Campuses</option>
                    {campuses.map(campus => <option key={campus.id} value={campus.id}>{campus.name}</option>)}
                  </select>
                  <select value={newPost.category} onChange={e => setNewPost({...newPost, category: e.target.value})}>
                    <option value="announcement">Announcement</option>
                    <option value="event">Event</option>
                    <option value="sermon">Sermon</option>
                    <option value="mission">Mission</option>
                    <option value="groups">Groups</option>
                    <option value="nextsteps">Next Steps</option>
                  </select>
                  <ImageUploader value={newPost.image_url} onChange={url => setNewPost({...newPost, image_url: url})} folder="posts" />
                  <div className="studio-actions">
                    {editingPostId ? (
                      <>
                        <button onClick={() => updatePost('draft')} className="draft-btn">Save as Draft</button>
                        <button onClick={() => updatePost('published')} className="send-btn">Update & Publish</button>
                      </>
                    ) : (
                      <>
                        <button onClick={() => savePost('draft')} className="draft-btn">Save Draft</button>
                        <button onClick={() => savePost('published')} className="send-btn">Publish</button>
                      </>
                    )}
                  </div>
                  {postStatus && <p className="status">{postStatus}</p>}
                </div>
                <div style={{marginTop: '32px'}}>
                  <h3 style={{color: 'white', marginBottom: '16px', fontSize: '18px', fontWeight: '600'}}>All Posts</h3>
                  {posts.length === 0 ? (
                    <p style={{color: 'rgba(255,255,255,0.5)'}}>No posts yet.</p>
                  ) : (
                    posts.map(post => (
                      <div key={post.id} className={`post-list-item ${editingPostId === post.id ? 'editing' : ''}`}>
                        <div className="post-list-info">
                          <div className="post-list-header">
                            <span className="post-list-title">{post.title}</span>
                            <span className={`post-status-badge ${post.status}`}>{post.status}</span>
                          </div>
                          <div className="post-list-meta">
                            <span>{post.category}</span>
                            <span>·</span>
                            <span>{getCampusName(post.campus_id)}</span>
                          </div>
                        </div>
                        <div className="row-actions">
                          <button onClick={() => startEditPost(post)} className="icon-btn" title="Edit">✎</button>
                          <button onClick={() => deletePost(post.id)} className="icon-btn icon-danger" title="Delete">🗑</button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
              <div className="studio-preview">
                <h3>Live Preview</h3>
                <div className="phone-frame">
                  <div className="phone-header">
                    <span className="phone-app-name">recvd.</span>
                    <span className="phone-campus">{getCampusName(newPost.campus_id)}</span>
                  </div>
                  <div className="phone-content">
                    {newPost.title || newPost.body || newPost.image_url ? (
                      <div className="preview-post-card">
                        {newPost.image_url && <img src={newPost.image_url} alt="" className="preview-image" />}
                        <span className="preview-category">{newPost.category}</span>
                        <h4 className="preview-title">{newPost.title || 'Your title here...'}</h4>
                        <p className="preview-body">{newPost.body || 'Your message will appear here...'}</p>
                      </div>
                    ) : (
                      <div className="preview-empty">
                        <p>Start typing to see your post preview →</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'events' && !selectedEventId && (
          <div>
            <div className="tab-header">
              <h2>Events</h2>
              <button className="send-btn" onClick={openNewEvent}>+ New Event</button>
            </div>
            {eventStatus && <p className="status">{eventStatus}</p>}

            {showEventForm && (
              <div className="comm-form" style={{marginBottom: '24px'}}>
                <div className="tab-header" style={{marginBottom: 0}}>
                  <h3>{editingEventId ? 'Edit Event' : 'New Event'}</h3>
                  <button className="icon-btn" onClick={() => { setShowEventForm(false); setEditingEventId(null); setEventDraft(emptyEvent); }}>Cancel</button>
                </div>
                <input type="text" placeholder="Event title" value={eventDraft.title} onChange={e => setEventDraft({...eventDraft, title: e.target.value})} />
                <textarea placeholder="Description" value={eventDraft.description} onChange={e => setEventDraft({...eventDraft, description: e.target.value})} style={{minHeight: '100px'}} />
                <div className="form-row">
                  <div style={{flex: 1}}>
                    <label className="field-label">Start</label>
                    <input type="datetime-local" value={eventDraft.start_at} onChange={e => setEventDraft({...eventDraft, start_at: e.target.value})} />
                  </div>
                  <div style={{flex: 1}}>
                    <label className="field-label">End (optional)</label>
                    <input type="datetime-local" value={eventDraft.end_at} onChange={e => setEventDraft({...eventDraft, end_at: e.target.value})} />
                  </div>
                </div>
                <input type="text" placeholder="Location (e.g. Main Auditorium or 123 Main St)" value={eventDraft.location} onChange={e => setEventDraft({...eventDraft, location: e.target.value})} />
                <div className="form-row">
                  <select value={eventDraft.campus_id || ''} onChange={e => setEventDraft({...eventDraft, campus_id: e.target.value})}>
                    <option value="">All Campuses</option>
                    {campuses.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                  <select value={eventDraft.category} onChange={e => setEventDraft({...eventDraft, category: e.target.value})}>
                    <option value="worship">Worship</option>
                    <option value="students">Students</option>
                    <option value="kids">Kids</option>
                    <option value="community">Community</option>
                    <option value="volunteer">Volunteer</option>
                    <option value="serve">Serve</option>
                  </select>
                </div>
                <div className="form-row">
                  <div style={{flex: 1}}>
                    <label className="field-label">Capacity</label>
                    <input type="number" min="1" placeholder="Leave blank for unlimited" value={eventDraft.capacity} onChange={e => setEventDraft({...eventDraft, capacity: e.target.value})} />
                  </div>
                  <div style={{flex: 2}}>
                    <ImageUploader value={eventDraft.image_url} onChange={url => setEventDraft({...eventDraft, image_url: url})} folder="events" />
                  </div>
                </div>
                <label className="checkbox-row">
                  <input type="checkbox" checked={eventDraft.registration_open} onChange={e => setEventDraft({...eventDraft, registration_open: e.target.checked})} />
                  <span>Registration open</span>
                </label>
                <div className="studio-actions">
                  <button onClick={() => saveEvent('draft')} className="draft-btn">Save Draft</button>
                  <button onClick={() => saveEvent('published')} className="send-btn">
                    {editingEventId ? 'Update & Publish' : 'Publish'}
                  </button>
                </div>
              </div>
            )}

            <div className="audience-options" style={{marginBottom: '16px'}}>
              <button className={eventsFilter === 'upcoming' ? 'active' : ''} onClick={() => setEventsFilter('upcoming')}>Upcoming</button>
              <button className={eventsFilter === 'past' ? 'active' : ''} onClick={() => setEventsFilter('past')}>Past</button>
              <button className={eventsFilter === 'all' ? 'active' : ''} onClick={() => setEventsFilter('all')}>All</button>
            </div>

            {filteredEvents.length === 0 ? (
              <p style={{color: 'rgba(255,255,255,0.5)'}}>No events in this view.</p>
            ) : (
              <div className="event-admin-grid">
                {filteredEvents.map(ev => (
                  <div key={ev.id} className="event-admin-card">
                    {ev.image_url && <img src={ev.image_url} alt="" className="event-admin-image" />}
                    <div className="event-admin-body">
                      <div className="event-admin-header">
                        <span className={`post-status-badge ${ev.status}`}>{ev.status}</span>
                        <span className="event-admin-category">{ev.category}</span>
                      </div>
                      <h3 className="event-admin-title">{ev.title}</h3>
                      <p className="event-admin-meta">
                        {new Date(ev.start_at).toLocaleString()}<br/>
                        {ev.location && <>📍 {ev.location}<br/></>}
                        {ev.campus_id ? getCampusName(ev.campus_id) : 'All Campuses'}
                        {ev.capacity ? ` · cap ${ev.capacity}` : ''}
                      </p>
                      <div className="row-actions">
                        <button onClick={() => openEventRoster(ev)} className="icon-btn" title="Roster">👥 Roster</button>
                        <button onClick={() => openEditEvent(ev)} className="icon-btn" title="Edit">✎</button>
                        <button onClick={() => deleteEvent(ev)} className="icon-btn icon-danger" title="Delete">🗑</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'events' && selectedEventId && selectedEvent && (
          <div>
            <div className="tab-header">
              <div>
                <button className="icon-btn" onClick={closeEventRoster}>← Back to events</button>
                <h2 style={{marginTop: '12px'}}>{selectedEvent.title}</h2>
                <p style={{color: 'rgba(255,255,255,0.7)', fontSize: '14px'}}>
                  {new Date(selectedEvent.start_at).toLocaleString()} · {selectedEvent.location || 'Location TBD'}
                </p>
              </div>
              <button onClick={exportRosterCSV} className="send-btn">Export CSV</button>
            </div>

            <div className="stats" style={{marginBottom: '24px'}}>
              <div className="stat-card">
                <h3>{registrations.filter(r => r.status === 'registered' || r.status === 'attended').length}</h3>
                <p>Registered</p>
              </div>
              <div className="stat-card">
                <h3>{registrations.filter(r => r.status === 'waitlist').length}</h3>
                <p>Waitlist</p>
              </div>
              <div className="stat-card">
                <h3>{registrations.filter(r => r.status === 'attended').length}</h3>
                <p>Attended</p>
              </div>
              {selectedEvent.capacity && (
                <div className="stat-card">
                  <h3>{selectedEvent.capacity}</h3>
                  <p>Capacity</p>
                </div>
              )}
            </div>

            <input
              type="text"
              placeholder="Search roster..."
              value={rosterSearch}
              onChange={e => setRosterSearch(e.target.value)}
              style={{marginBottom: '16px', maxWidth: '400px', padding: '10px 14px', background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '10px', color: 'white', fontSize: '14px'}}
            />

            {filteredRegistrations.length === 0 ? (
              <p style={{color: 'rgba(255,255,255,0.5)'}}>No registrations yet.</p>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Name</th><th>Email</th><th>Phone</th><th>Guests</th><th>Status</th><th>Registered</th><th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRegistrations.map(r => (
                    <tr key={r.id}>
                      <td>{r.name}</td>
                      <td>{r.email || '—'}</td>
                      <td>{r.phone || '—'}</td>
                      <td>{r.guests_count}</td>
                      <td>
                        <select value={r.status} onChange={e => updateRegistration(r.id, { status: e.target.value })} style={{padding: '4px 8px', background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px', color: 'white', fontSize: '12px'}}>
                          <option value="registered">Registered</option>
                          <option value="waitlist">Waitlist</option>
                          <option value="attended">Attended</option>
                          <option value="cancelled">Cancelled</option>
                        </select>
                      </td>
                      <td>{new Date(r.registered_at).toLocaleDateString()}</td>
                      <td>
                        <button onClick={() => removeRegistration(r.id)} className="icon-btn icon-danger" title="Remove">🗑</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {activeTab === 'sermons' && (
          <div>
            <div className="tab-header">
              <h2>Sermons</h2>
              <button className="send-btn" onClick={openNewSermon}>+ Add Sermon</button>
            </div>
            {sermonStatus && <p className="status">{sermonStatus}</p>}

            {showSermonForm && (
              <div className="comm-form" style={{marginBottom: '24px'}}>
                <div className="tab-header" style={{marginBottom: 0}}>
                  <h3>{editingSermonId ? 'Edit Sermon' : 'New Sermon'}</h3>
                  <button className="icon-btn" onClick={() => { setShowSermonForm(false); setEditingSermonId(null); setSermonDraft(emptySermon); }}>Cancel</button>
                </div>
                <input type="text" placeholder="Sermon title" value={sermonDraft.title} onChange={e => setSermonDraft({...sermonDraft, title: e.target.value})} />
                <div className="form-row">
                  <input type="text" placeholder="Series (e.g. He Is Risen)" value={sermonDraft.series} onChange={e => setSermonDraft({...sermonDraft, series: e.target.value})} />
                  <input type="text" placeholder="Speaker" value={sermonDraft.speaker} onChange={e => setSermonDraft({...sermonDraft, speaker: e.target.value})} />
                </div>
                <input type="text" placeholder="Scripture reference (e.g. John 3:16)" value={sermonDraft.scripture_reference} onChange={e => setSermonDraft({...sermonDraft, scripture_reference: e.target.value})} />
                <textarea placeholder="Description / notes" value={sermonDraft.description} onChange={e => setSermonDraft({...sermonDraft, description: e.target.value})} style={{minHeight: '80px'}} />
                <input type="url" placeholder="Video URL (YouTube or Vimeo)" value={sermonDraft.video_url} onChange={e => setSermonDraft({...sermonDraft, video_url: e.target.value})} />
                <input type="url" placeholder="Audio URL (optional)" value={sermonDraft.audio_url} onChange={e => setSermonDraft({...sermonDraft, audio_url: e.target.value})} />
                <ImageUploader value={sermonDraft.thumbnail_url} onChange={url => setSermonDraft({...sermonDraft, thumbnail_url: url})} folder="sermons" />
                <div className="form-row">
                  <div style={{flex: 1}}>
                    <label className="field-label">Preached on</label>
                    <input type="datetime-local" value={sermonDraft.preached_at} onChange={e => setSermonDraft({...sermonDraft, preached_at: e.target.value})} />
                  </div>
                  <div style={{flex: 1}}>
                    <label className="field-label">Duration (seconds, optional)</label>
                    <input type="number" min="0" value={sermonDraft.duration_seconds} onChange={e => setSermonDraft({...sermonDraft, duration_seconds: e.target.value})} />
                  </div>
                </div>
                <select value={sermonDraft.campus_id || ''} onChange={e => setSermonDraft({...sermonDraft, campus_id: e.target.value})}>
                  <option value="">All Campuses</option>
                  {campuses.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
                <div className="studio-actions">
                  <button onClick={() => saveSermon('draft')} className="draft-btn">Save Draft</button>
                  <button onClick={() => saveSermon('published')} className="send-btn">
                    {editingSermonId ? 'Update & Publish' : 'Publish'}
                  </button>
                </div>
              </div>
            )}

            {sermons.length === 0 ? (
              <p style={{color: 'rgba(255,255,255,0.5)'}}>No sermons yet. Click + Add Sermon to upload one.</p>
            ) : (
              <div className="event-admin-grid">
                {sermons.map(s => (
                  <div key={s.id} className="event-admin-card">
                    {s.thumbnail_url && <img src={s.thumbnail_url} alt="" className="event-admin-image" />}
                    <div className="event-admin-body">
                      <div className="event-admin-header">
                        <span className={`post-status-badge ${s.status}`}>{s.status}</span>
                        {s.series && <span className="event-admin-category">{s.series}</span>}
                      </div>
                      <h3 className="event-admin-title">{s.title}</h3>
                      <p className="event-admin-meta">
                        {s.speaker && <>🎙 {s.speaker}<br/></>}
                        {s.scripture_reference && <>📖 {s.scripture_reference}<br/></>}
                        {s.preached_at && <>{new Date(s.preached_at).toLocaleDateString()}</>}
                      </p>
                      <div className="row-actions">
                        {s.video_url && <a href={s.video_url} target="_blank" rel="noreferrer" className="icon-btn" title="Watch">▶ Watch</a>}
                        <button onClick={() => openEditSermon(s)} className="icon-btn" title="Edit">✎</button>
                        <button onClick={() => deleteSermon(s)} className="icon-btn icon-danger" title="Delete">🗑</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'analytics' && (
          <div>
            <h2>Analytics</h2>

            {!analyticsOverview ? (
              <p style={{color: 'var(--text-muted)'}}>Loading…</p>
            ) : (
              <>
                <div className="stats">
                  <div className="stat-card"><h3>{analyticsOverview.total_members}</h3><p>Total Members</p></div>
                  <div className="stat-card"><h3>{analyticsOverview.weekly_active}</h3><p>Active (7d)</p></div>
                  <div className="stat-card"><h3>{analyticsOverview.daily_active}</h3><p>Active Today</p></div>
                  <div className="stat-card"><h3>+{analyticsOverview.new_this_week}</h3><p>New This Week</p></div>
                  <div className="stat-card"><h3>{analyticsOverview.event_registrations_30d}</h3><p>Event RSVPs (30d)</p></div>
                  <div className="stat-card"><h3>{analyticsOverview.devotional_completions_30d}</h3><p>Devo Completions (30d)</p></div>
                </div>

                <div style={{marginTop: '32px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r-lg)', padding: '24px', boxShadow: 'var(--shadow-sm)'}}>
                  <h3 style={{marginBottom: '4px'}}>Signups + Active Users</h3>
                  <p style={{color: 'var(--text-muted)', fontSize: '13px', marginBottom: '20px'}}>Last 30 days</p>
                  <TimeSeriesChart series={analyticsSeries} />
                </div>

                {analyticsEngagement && (
                  <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '20px', marginTop: '32px'}}>
                    <div className="comm-form" style={{gap: '12px'}}>
                      <h3>Feature Engagement (30d)</h3>
                      {analyticsEngagement.engagement.length === 0 ? (
                        <p style={{color: 'var(--text-muted)', fontSize: '13px'}}>No activity yet — members haven't opened the app.</p>
                      ) : analyticsEngagement.engagement.map(e => {
                        const max = analyticsEngagement.engagement[0].count
                        const pct = Math.max(5, Math.round(e.count / max * 100))
                        return (
                          <div key={e.type} className="engagement-bar">
                            <div className="engagement-label">
                              <span>{e.type.replace(/_/g, ' ')}</span>
                              <span className="engagement-count">{e.count}</span>
                            </div>
                            <div className="engagement-track"><div className="engagement-fill" style={{width: pct + '%'}} /></div>
                          </div>
                        )
                      })}
                    </div>

                    <div className="comm-form" style={{gap: '6px'}}>
                      <h3>Top Sermons (30d)</h3>
                      {analyticsEngagement.topSermons.length === 0 ? (
                        <p style={{color: 'var(--text-muted)', fontSize: '13px'}}>No sermon plays yet.</p>
                      ) : analyticsEngagement.topSermons.map((s, i) => (
                        <div key={s.id} className="top-row">
                          <span className="top-rank">{i + 1}</span>
                          <span className="top-title">{s.title}</span>
                          <span className="top-count">{s.count}</span>
                        </div>
                      ))}
                    </div>

                    <div className="comm-form" style={{gap: '6px'}}>
                      <h3>Top Events (30d)</h3>
                      {analyticsEngagement.topEvents.length === 0 ? (
                        <p style={{color: 'var(--text-muted)', fontSize: '13px'}}>No RSVPs yet.</p>
                      ) : analyticsEngagement.topEvents.map((e, i) => (
                        <div key={e.id} className="top-row">
                          <span className="top-rank">{i + 1}</span>
                          <span className="top-title">{e.title}</span>
                          <span className="top-count">{e.count}</span>
                        </div>
                      ))}
                    </div>

                    <div className="comm-form" style={{gap: '6px'}}>
                      <h3>Top Devotionals (30d)</h3>
                      {analyticsEngagement.topDevotionals.length === 0 ? (
                        <p style={{color: 'var(--text-muted)', fontSize: '13px'}}>No completions yet.</p>
                      ) : analyticsEngagement.topDevotionals.map((d, i) => (
                        <div key={d.id} className="top-row">
                          <span className="top-rank">{i + 1}</span>
                          <span className="top-title">{d.title}</span>
                          <span className="top-count">{d.count}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div style={{marginTop: '32px'}}>
                  <h3 style={{marginBottom: '12px'}}>Members — Last Active</h3>
                  {analyticsMembers.length === 0 ? (
                    <p style={{color: 'var(--text-muted)'}}>No members yet.</p>
                  ) : (
                    <table>
                      <thead>
                        <tr><th>Name</th><th>Email</th><th>Status</th><th>Campus</th><th>Last Seen</th></tr>
                      </thead>
                      <tbody>
                        {analyticsMembers.map(m => (
                          <tr key={m.id}>
                            <td>{m.first_name} {m.last_name}</td>
                            <td>{m.email}</td>
                            <td>{m.status}</td>
                            <td>{m.campus_id ? getCampusName(m.campus_id) : '—'}</td>
                            <td>{m.last_seen_at ? new Date(m.last_seen_at).toLocaleString() : <span style={{color: 'var(--text-subtle)'}}>never</span>}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </>
            )}
          </div>
        )}

        {activeTab === 'groups' && !selectedGroupId && (
          <div>
            <div className="tab-header">
              <h2>Groups</h2>
              <button className="send-btn" onClick={openNewGroup}>+ New Group</button>
            </div>
            {groupStatus && <p className="status">{groupStatus}</p>}

            {showGroupForm && (
              <div className="comm-form" style={{marginBottom: '24px', maxWidth: '820px'}}>
                <div className="tab-header" style={{marginBottom: 0}}>
                  <h3>{editingGroupId ? 'Edit Group' : 'New Group'}</h3>
                  <button className="icon-btn" onClick={() => { setShowGroupForm(false); setEditingGroupId(null); setGroupDraft(emptyGroup); }}>Cancel</button>
                </div>
                <input type="text" placeholder="Group name (e.g. Young Families)" value={groupDraft.name} onChange={e => setGroupDraft({...groupDraft, name: e.target.value})} />
                <textarea placeholder="Description" value={groupDraft.description} onChange={e => setGroupDraft({...groupDraft, description: e.target.value})} style={{minHeight: '80px'}} />
                <div className="form-row">
                  <select value={groupDraft.category} onChange={e => setGroupDraft({...groupDraft, category: e.target.value})}>
                    <option value="small_group">Small Group</option>
                    <option value="serve_team">Serve Team</option>
                    <option value="class">Class</option>
                    <option value="mens">Men's</option>
                    <option value="womens">Women's</option>
                    <option value="youth">Youth</option>
                    <option value="kids">Kids</option>
                    <option value="other">Other</option>
                  </select>
                  <select value={groupDraft.campus_id || ''} onChange={e => setGroupDraft({...groupDraft, campus_id: e.target.value})}>
                    <option value="">All Campuses</option>
                    {campuses.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </div>
                <div className="form-row">
                  <input type="text" placeholder="Meeting day (e.g. Thursdays)" value={groupDraft.meeting_day} onChange={e => setGroupDraft({...groupDraft, meeting_day: e.target.value})} />
                  <input type="text" placeholder="Meeting time (e.g. 7:00 PM)" value={groupDraft.meeting_time} onChange={e => setGroupDraft({...groupDraft, meeting_time: e.target.value})} />
                </div>
                <input type="text" placeholder="Location" value={groupDraft.location} onChange={e => setGroupDraft({...groupDraft, location: e.target.value})} />
                <div className="form-row">
                  <input type="text" placeholder="Leader name" value={groupDraft.leader_name} onChange={e => setGroupDraft({...groupDraft, leader_name: e.target.value})} />
                  <input type="text" placeholder="Leader contact (email/phone)" value={groupDraft.leader_contact} onChange={e => setGroupDraft({...groupDraft, leader_contact: e.target.value})} />
                </div>
                <div className="form-row">
                  <div style={{flex: 1}}>
                    <label className="field-label">Capacity (leave blank for unlimited)</label>
                    <input type="number" min="1" value={groupDraft.capacity} onChange={e => setGroupDraft({...groupDraft, capacity: e.target.value})} />
                  </div>
                  <div style={{flex: 2}}>
                    <ImageUploader value={groupDraft.image_url} onChange={url => setGroupDraft({...groupDraft, image_url: url})} folder="groups" />
                  </div>
                </div>
                <div className="studio-actions">
                  <button onClick={() => saveGroup('draft')} className="draft-btn">Save Draft</button>
                  <button onClick={() => saveGroup('published')} className="send-btn">
                    {editingGroupId ? 'Update & Publish' : 'Publish'}
                  </button>
                </div>
              </div>
            )}

            {groups.length === 0 ? (
              <p style={{color: 'var(--text-muted)'}}>No groups yet. Click + New Group to add one.</p>
            ) : (
              <div className="event-admin-grid">
                {groups.map(g => (
                  <div key={g.id} className="event-admin-card">
                    {g.image_url && <img src={g.image_url} alt="" className="event-admin-image" />}
                    <div className="event-admin-body">
                      <div className="event-admin-header">
                        <span className={`post-status-badge ${g.status}`}>{g.status}</span>
                        <span className="event-admin-category">{g.category.replace('_', ' ')}</span>
                      </div>
                      <h3 className="event-admin-title">{g.name}</h3>
                      <p className="event-admin-meta">
                        {g.meeting_day && <>📅 {g.meeting_day}{g.meeting_time ? ` · ${g.meeting_time}` : ''}<br/></>}
                        {g.location && <>📍 {g.location}<br/></>}
                        {g.leader_name && <>👤 {g.leader_name}<br/></>}
                        {g.campus_id ? getCampusName(g.campus_id) : 'All Campuses'}
                        {g.capacity ? ` · cap ${g.capacity}` : ''}
                      </p>
                      <div className="row-actions">
                        <button onClick={() => openGroupRoster(g)} className="icon-btn">👥 Roster</button>
                        <button onClick={() => openEditGroup(g)} className="icon-btn">✎</button>
                        <button onClick={() => deleteGroup(g)} className="icon-btn icon-danger">🗑</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'groups' && selectedGroupId && selectedGroup && (
          <div>
            <div className="tab-header">
              <div>
                <button className="icon-btn" onClick={closeGroupRoster}>← Back to groups</button>
                <h2 style={{marginTop: '12px'}}>{selectedGroup.name}</h2>
                <p style={{color: 'var(--text-muted)', fontSize: '14px'}}>
                  {selectedGroup.meeting_day} {selectedGroup.meeting_time} · {selectedGroup.location || 'Location TBD'}
                </p>
              </div>
            </div>

            <div className="stats" style={{marginBottom: '24px'}}>
              <div className="stat-card">
                <h3>{groupRoster.length}</h3>
                <p>Members</p>
              </div>
              {selectedGroup.capacity && (
                <div className="stat-card">
                  <h3>{selectedGroup.capacity}</h3>
                  <p>Capacity</p>
                </div>
              )}
            </div>

            {groupRoster.length === 0 ? (
              <p style={{color: 'var(--text-muted)'}}>No members yet.</p>
            ) : (
              <table>
                <thead>
                  <tr><th>Name</th><th>Email</th><th>Phone</th><th>Role</th><th>Joined</th><th>Actions</th></tr>
                </thead>
                <tbody>
                  {groupRoster.map(r => (
                    <tr key={r.id}>
                      <td>{r.members?.first_name} {r.members?.last_name}</td>
                      <td>{r.members?.email || '—'}</td>
                      <td>{r.members?.phone || '—'}</td>
                      <td>{r.role}</td>
                      <td>{new Date(r.joined_at).toLocaleDateString()}</td>
                      <td><button onClick={() => removeGroupMember(r.member_id)} className="icon-btn icon-danger">🗑</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {activeTab === 'devotionals' && (
          <div>
            <div className="tab-header">
              <h2>Devotionals</h2>
              <button className="send-btn" onClick={openNewDevo}>+ New Devotional</button>
            </div>
            {devoStatus && <p className="status">{devoStatus}</p>}

            {showDevoForm && (
              <div className="comm-form" style={{marginBottom: '24px', maxWidth: '820px'}}>
                <div className="tab-header" style={{marginBottom: 0}}>
                  <h3>{editingDevoId ? 'Edit Devotional' : 'New Devotional'}</h3>
                  <button className="icon-btn" onClick={() => { setShowDevoForm(false); setEditingDevoId(null); setDevoDraft(emptyDevo); }}>Cancel</button>
                </div>
                <input type="text" placeholder="Title (e.g. Rooted in Grace)" value={devoDraft.title} onChange={e => setDevoDraft({...devoDraft, title: e.target.value})} />
                <div className="form-row">
                  <input type="text" placeholder="Series (e.g. 40 Days of Easter)" value={devoDraft.series} onChange={e => setDevoDraft({...devoDraft, series: e.target.value})} />
                  <input type="text" placeholder="Author" value={devoDraft.author} onChange={e => setDevoDraft({...devoDraft, author: e.target.value})} />
                </div>
                <div className="form-row">
                  <div style={{flex: 1}}>
                    <label className="field-label">Available on</label>
                    <input type="date" value={devoDraft.available_on} onChange={e => setDevoDraft({...devoDraft, available_on: e.target.value})} />
                  </div>
                  <div style={{flex: 1}}>
                    <ImageUploader value={devoDraft.image_url} onChange={url => setDevoDraft({...devoDraft, image_url: url})} folder="devotionals" />
                  </div>
                </div>
                <input type="text" placeholder="Scripture reference (e.g. John 3:16)" value={devoDraft.scripture_reference} onChange={e => setDevoDraft({...devoDraft, scripture_reference: e.target.value})} />
                <textarea placeholder="Scripture text (the verse, pulled out as a quote)" value={devoDraft.scripture_text} onChange={e => setDevoDraft({...devoDraft, scripture_text: e.target.value})} style={{minHeight: '60px'}} />
                <textarea placeholder="Devotional body — the main reading (supports line breaks)" value={devoDraft.body} onChange={e => setDevoDraft({...devoDraft, body: e.target.value})} style={{minHeight: '200px'}} />
                <textarea placeholder="Reflection question (e.g. How does this change how you see ___?)" value={devoDraft.reflection_question} onChange={e => setDevoDraft({...devoDraft, reflection_question: e.target.value})} style={{minHeight: '60px'}} />
                <div className="studio-actions">
                  <button onClick={() => saveDevo('draft')} className="draft-btn">Save Draft</button>
                  <button onClick={() => saveDevo('published')} className="send-btn">
                    {editingDevoId ? 'Update & Publish' : 'Publish'}
                  </button>
                </div>
              </div>
            )}

            {devotionals.length === 0 ? (
              <p style={{color: 'var(--text-muted)'}}>No devotionals yet. Click + New Devotional to add one.</p>
            ) : (
              <div className="event-admin-grid">
                {devotionals.map(d => (
                  <div key={d.id} className="event-admin-card">
                    {d.image_url && <img src={d.image_url} alt="" className="event-admin-image" />}
                    <div className="event-admin-body">
                      <div className="event-admin-header">
                        <span className={`post-status-badge ${d.status}`}>{d.status}</span>
                        {d.series && <span className="event-admin-category">{d.series}</span>}
                      </div>
                      <h3 className="event-admin-title">{d.title}</h3>
                      <p className="event-admin-meta">
                        {d.scripture_reference && <>📖 {d.scripture_reference}<br/></>}
                        {d.author && <>✍️ {d.author}<br/></>}
                        {d.available_on && <>📅 {new Date(d.available_on + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</>}
                      </p>
                      <div className="row-actions">
                        <button onClick={() => openEditDevo(d)} className="icon-btn" title="Edit">✎</button>
                        <button onClick={() => deleteDevo(d)} className="icon-btn icon-danger" title="Delete">🗑</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'communications' && (
          <div>
            <h2>Communications</h2>
            <div className="comm-form">
              <div className="channel-toggle">
                <button
                  className={commsChannel === 'email' ? 'active' : ''}
                  onClick={() => setCommsChannel('email')}
                >✉️ Email</button>
                <button
                  className={commsChannel === 'sms' ? 'active' : ''}
                  onClick={() => setCommsChannel('sms')}
                >💬 SMS</button>
                <button
                  className={commsChannel === 'push' ? 'active' : ''}
                  onClick={() => { setCommsChannel('push'); refreshPushReach(); }}
                >🔔 Push</button>
              </div>

              <h3>{commsChannel === 'email' ? 'Send Email' : commsChannel === 'sms' ? 'Send SMS' : 'Send Push Notification'}</h3>

              <div className="audience-selector">
                <label>Audience</label>
                <div className="audience-options">
                  <button className={audienceType === 'individual' ? 'active' : ''} onClick={() => setAudienceType('individual')}>Individual</button>
                  <button className={audienceType === 'all' ? 'active' : ''} onClick={() => setAudienceType('all')}>All Members ({members.length})</button>
                  <button className={audienceType === 'campus' ? 'active' : ''} onClick={() => setAudienceType('campus')}>By Campus</button>
                  <button className={audienceType === 'tag' ? 'active' : ''} onClick={() => setAudienceType('tag')}>By Tag</button>
                </div>
              </div>

              {audienceType === 'individual' && commsChannel === 'email' && (
                <div className="member-search-container">
                  {emailToName ? (
                    <div className="selected-member">
                      <span>✉️ {emailToName}</span>
                      <button onClick={() => { setEmailTo(''); setEmailToName(''); setMemberSearch(''); }} className="tag-add-btn">✕</button>
                    </div>
                  ) : (
                    <div>
                      <input type="text" placeholder="Search by name..." value={memberSearch} onChange={e => setMemberSearch(e.target.value)} />
                      {memberSearch && (
                        <div className="member-search-results">
                          {filteredMembers.length === 0 ? (
                            <div className="search-result-item">No members found</div>
                          ) : (
                            filteredMembers.map(m => (
                              <div key={m.id} className="search-result-item" onClick={() => { setEmailTo(m.email); setEmailToName(`${m.first_name} ${m.last_name}`); setMemberSearch(''); }}>
                                {m.first_name} {m.last_name} — {m.email}
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {audienceType === 'individual' && commsChannel === 'sms' && (
                <div className="member-search-container">
                  {smsToName ? (
                    <div className="selected-member">
                      <span>💬 {smsToName}</span>
                      <button onClick={() => { setSmsTo(''); setSmsToName(''); setMemberSearch(''); }} className="tag-add-btn">✕</button>
                    </div>
                  ) : (
                    <div>
                      <input type="text" placeholder="Search by name..." value={memberSearch} onChange={e => setMemberSearch(e.target.value)} />
                      {memberSearch && (
                        <div className="member-search-results">
                          {filteredMembers.filter(m => m.phone).length === 0 ? (
                            <div className="search-result-item">No members with phone numbers</div>
                          ) : (
                            filteredMembers.filter(m => m.phone).map(m => (
                              <div key={m.id} className="search-result-item" onClick={() => { setSmsTo(m.phone); setSmsToName(`${m.first_name} ${m.last_name}`); setMemberSearch(''); }}>
                                {m.first_name} {m.last_name} — {m.phone}
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {audienceType === 'campus' && (
                <select value={selectedCampus} onChange={e => setSelectedCampus(e.target.value)}>
                  <option value="">Select a campus...</option>
                  {campuses.map(campus => <option key={campus.id} value={campus.id}>{campus.name}</option>)}
                </select>
              )}
              {audienceType === 'tag' && (
                <select value={selectedTag} onChange={e => setSelectedTag(e.target.value)}>
                  <option value="">Select a tag...</option>
                  {tags.map(tag => <option key={tag.id} value={tag.id}>{tag.name}</option>)}
                </select>
              )}

              {commsChannel === 'email' ? (
                <>
                  <input type="text" placeholder="Subject" value={emailSubject} onChange={e => setEmailSubject(e.target.value)} />
                  <textarea placeholder="Message" value={emailMessage} onChange={e => setEmailMessage(e.target.value)} />
                  <button onClick={sendEmail} className="send-btn">Send Email</button>
                  {emailStatus && <p className="status">{emailStatus}</p>}
                </>
              ) : commsChannel === 'push' ? (
                <>
                  {pushReach && (
                    <div className="compliance-note" style={{background: 'var(--accent-soft)', color: 'var(--accent)', borderColor: 'var(--accent)'}}>
                      📱 Reach: {pushReach.member_count} of {pushReach.total_members_in_audience} members in this audience have the app installed ({pushReach.device_count} devices total)
                      {pushReach.member_count === 0 && ' — nothing to send to yet'}
                    </div>
                  )}
                  <input type="text" placeholder="Title (e.g. New sermon just dropped)" value={pushTitle} onChange={e => setPushTitle(e.target.value)} />
                  <textarea placeholder="Message body" value={pushBody} onChange={e => setPushBody(e.target.value)} style={{minHeight: '80px'}} />
                  <input type="text" placeholder="Deep link (optional, e.g. /sermons/42)" value={pushLink} onChange={e => setPushLink(e.target.value)} />
                  <button onClick={() => { refreshPushReach(); sendPush(); }} className="send-btn">Send Notification</button>
                  {pushStatus && <p className="status">{pushStatus}</p>}
                </>
              ) : (
                <>
                  <div className="compliance-note">
                    ⚠️ Only text members who have opted in to receive SMS from the church.
                  </div>
                  <textarea placeholder="Text message..." value={smsMessage} onChange={e => setSmsMessage(e.target.value)} />
                  <label className="checkbox-row">
                    <input
                      type="checkbox"
                      checked={includeOptOutFooter}
                      onChange={e => setIncludeOptOutFooter(e.target.checked)}
                    />
                    <span>Append "— Reply STOP to opt out" (recommended for mass texts)</span>
                  </label>
                  <div className="char-counter">
                    {(() => {
                      const c = smsCounts()
                      return (
                        <>
                          <span>{c.len} chars · {c.per}/segment{c.unicode ? ' (Unicode)' : ''}</span>
                          <span className={c.segs > 1 ? 'char-warn' : ''}>
                            {c.segs === 0 ? '—' : `${c.segs} segment${c.segs > 1 ? 's' : ''}`}
                          </span>
                        </>
                      )
                    })()}
                  </div>
                  <button onClick={sendSMS} className="send-btn">Send SMS</button>
                  {smsStatus && <p className="status">{smsStatus}</p>}
                </>
              )}
            </div>

            <div style={{marginTop: '32px'}}>
              <h3 style={{marginBottom: '16px', fontSize: '18px', fontWeight: '600'}}>
                {commsChannel === 'email' ? 'Email History' : commsChannel === 'sms' ? 'SMS History' : 'Push History'}
              </h3>
              {commsChannel === 'push' ? (
                pushHistory.length === 0 ? (
                  <p style={{color: 'var(--text-muted)'}}>No notifications sent yet.</p>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th>Title</th><th>Body</th><th>Audience</th><th>Devices</th><th>Members</th><th>Sent At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pushHistory.map(p => (
                        <tr key={p.id}>
                          <td>{p.title}</td>
                          <td style={{maxWidth: 280, whiteSpace: 'pre-wrap'}}>{p.body || '—'}</td>
                          <td>{p.audience_type}</td>
                          <td>{p.recipient_count}</td>
                          <td>{p.member_count}</td>
                          <td>{new Date(p.sent_at).toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )
              ) : commsChannel === 'email' ? (
                emailHistory.length === 0 ? (
                  <p style={{color: 'rgba(255,255,255,0.5)'}}>No emails sent yet.</p>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th>Subject</th><th>Audience</th><th>Recipients</th><th>Sent At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {emailHistory.map(email => (
                        <tr key={email.id}>
                          <td>{email.subject}</td>
                          <td>{email.audience_type}</td>
                          <td>{email.recipient_count}</td>
                          <td>{new Date(email.sent_at).toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )
              ) : (
                smsHistory.length === 0 ? (
                  <p style={{color: 'rgba(255,255,255,0.5)'}}>No texts sent yet.</p>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th>Message</th><th>Audience</th><th>Recipients</th><th>Sent At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {smsHistory.map(sms => (
                        <tr key={sms.id}>
                          <td style={{maxWidth: '400px', whiteSpace: 'pre-wrap'}}>{sms.message}</td>
                          <td>{sms.audience_type}</td>
                          <td>{sms.recipient_count}</td>
                          <td>{new Date(sms.sent_at).toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ========================
// TimeSeriesChart — simple inline SVG chart, no external deps
// ========================
function TimeSeriesChart({ series }) {
  if (!series || series.length === 0) {
    return <p style={{color: 'var(--text-muted)', fontSize: '13px'}}>No data yet.</p>;
  }
  const width = 720;
  const height = 220;
  const padding = { top: 16, right: 16, bottom: 28, left: 32 };
  const innerW = width - padding.left - padding.right;
  const innerH = height - padding.top - padding.bottom;
  const maxVal = Math.max(1, ...series.flatMap(d => [d.signups, d.active]));
  const xStep = innerW / Math.max(1, series.length - 1);
  const path = (key) => series.map((d, i) => {
    const x = padding.left + i * xStep;
    const y = padding.top + innerH - (d[key] / maxVal) * innerH;
    return `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(' ');
  // Reduced x-axis ticks: first, middle, last
  const tickIndexes = [0, Math.floor(series.length / 2), series.length - 1].filter((v, i, a) => a.indexOf(v) === i);

  return (
    <div className="chart-wrap">
      <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="xMidYMid meet" style={{width: '100%', height: 'auto'}}>
        {/* Y gridlines */}
        {[0, 0.25, 0.5, 0.75, 1].map(p => {
          const y = padding.top + innerH - p * innerH;
          return <line key={p} x1={padding.left} x2={width - padding.right} y1={y} y2={y} stroke="var(--border)" strokeDasharray="2 3" />;
        })}
        {/* Paths */}
        <path d={path('active')} fill="none" stroke="var(--accent)" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
        <path d={path('signups')} fill="none" stroke="var(--success)" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" strokeDasharray="4 4" />
        {/* Y axis labels */}
        {[0, 0.5, 1].map(p => {
          const y = padding.top + innerH - p * innerH;
          const value = Math.round(p * maxVal);
          return <text key={p} x={padding.left - 6} y={y + 4} fontSize="11" textAnchor="end" fill="var(--text-muted)">{value}</text>;
        })}
        {/* X axis labels */}
        {tickIndexes.map(i => {
          const x = padding.left + i * xStep;
          const d = new Date(series[i].date + 'T00:00:00Z');
          const label = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          return <text key={i} x={x} y={height - 10} fontSize="11" textAnchor="middle" fill="var(--text-muted)">{label}</text>;
        })}
      </svg>
      <div className="chart-legend">
        <span><span className="chart-swatch" style={{background: 'var(--accent)'}}></span>Active users</span>
        <span><span className="chart-swatch" style={{background: 'var(--success)'}}></span>Signups</span>
      </div>
    </div>
  );
}

// ========================
// ImageUploader — file picker + Supabase Storage upload, falls back to URL paste
// ========================
function ImageUploader({ value, onChange, folder }) {
  const [uploading, setUploading] = React.useState(false);
  const [error, setError] = React.useState('');
  const inputRef = React.useRef(null);

  const handleFile = async (file) => {
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      setError('Please pick an image file.');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      setError('Image must be under 10 MB.');
      return;
    }
    setError('');
    setUploading(true);
    try {
      const ext = (file.name.split('.').pop() || 'jpg').toLowerCase();
      const path = `${folder || 'misc'}/${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;
      const { error: upErr } = await supabase.storage.from('images').upload(path, file, { upsert: false });
      if (upErr) throw upErr;
      const { data } = supabase.storage.from('images').getPublicUrl(path);
      onChange(data.publicUrl);
    } catch (e) {
      setError(e?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer?.files?.[0]) handleFile(e.dataTransfer.files[0]);
  };

  return (
    <div>
      <label className="field-label">Image</label>
      <div
        className={`image-uploader ${uploading ? 'uploading' : ''}`}
        onClick={() => !uploading && inputRef.current?.click()}
        onDragOver={e => { e.preventDefault(); e.stopPropagation(); }}
        onDrop={handleDrop}
      >
        {value ? (
          <div className="image-uploader-preview">
            <img src={value} alt="" />
            <button type="button" className="image-uploader-change" onClick={e => { e.stopPropagation(); onChange(''); }}>Remove</button>
          </div>
        ) : (
          <div className="image-uploader-empty">
            {uploading ? '⏳ Uploading…' : <>📷 <span>Click or drop an image</span><small>JPG / PNG / WebP / GIF, up to 10 MB</small></>}
          </div>
        )}
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          style={{display: 'none'}}
          onChange={e => handleFile(e.target.files?.[0])}
        />
      </div>
      {error && <p style={{color: 'var(--danger)', fontSize: '13px', marginTop: '6px'}}>{error}</p>}
      <input
        type="url"
        placeholder="…or paste a URL"
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        style={{marginTop: '8px'}}
      />
    </div>
  );
}

export default App;